import { SurveyStatus } from "../../../redux/survey/survey.types";

const DASHBOARD_SURVEY_LIST_PAGE_SIZE = 12;
const FILTER_STATUS_LIST = [SurveyStatus.Live, SurveyStatus.Complete, SurveyStatus.Draft] as const;
type FilterStatus = typeof FILTER_STATUS_LIST[number];

const ENTITY_FILTER_LIST = ['all', 'surveys', 'groups'] as const;
type EntityFilter = typeof ENTITY_FILTER_LIST[number];

export { ENTITY_FILTER_LIST, FILTER_STATUS_LIST, DASHBOARD_SURVEY_LIST_PAGE_SIZE };
export type { EntityFilter, FilterStatus };
